export const timeZoneToCountryMap = {
    // === Africa ===
    "Africa/Abidjan": "CI", // Côte d'Ivoire (also covers BF, GH, GM, GN, ML, MR, SH, SL, SN, TG)
    "Africa/Accra": "GH",   // Alias for Africa/Abidjan for Ghana
    "Africa/Addis_Ababa": "ET", // Ethiopia (alias for Africa/Nairobi)
    "Africa/Algiers": "DZ", // Algeria
    "Africa/Bamako": "ML",  // Alias for Africa/Abidjan for Mali
    "Africa/Bissau": "GW",  // Guinea-Bissau
    "Africa/Cairo": "EG",   // Egypt
    "Africa/Casablanca": "MA", // Morocco
    "Africa/Conakry": "GN", // Alias for Africa/Abidjan for Guinea
    "Africa/Dakar": "SN",   // Alias for Africa/Abidjan for Senegal
    "Africa/Dar_es_Salaam": "TZ", // Alias for Africa/Nairobi for Tanzania
    "Africa/Djibouti": "DJ", // Alias for Africa/Nairobi for Djibouti
    "Africa/Douala": "CM",  // Cameroon (alias for Africa/Lagos)
    "Africa/Freetown": "SL", // Alias for Africa/Abidjan for Sierra Leone
    "Africa/Gaborone": "BW", // Alias for Africa/Maputo for Botswana
    "Africa/Harare": "ZW",  // Zimbabwe (alias for Africa/Maputo)
    "Africa/Johannesburg": "ZA", // South Africa (also LS, SZ)
    "Africa/Kampala": "UG", // Alias for Africa/Nairobi for Uganda
    "Africa/Khartoum": "SD", // Sudan
    "Africa/Kigali": "RW",  // Alias for Africa/Maputo for Rwanda
    "Africa/Kinshasa": "CD", // DR Congo (west) (alias for Africa/Lagos)
    "Africa/Lagos": "NG",   // Nigeria (also AO, BJ, CF, CG, CM, GA, GQ, NE)
    "Africa/Libreville": "GA", // Alias for Africa/Lagos for Gabon
    "Africa/Lome": "TG",    // Alias for Africa/Abidjan for Togo
    "Africa/Luanda": "AO",  // Alias for Africa/Lagos for Angola
    "Africa/Maputo": "MZ",  // Mozambique (also BI, BW, CD, MW, RW, ZM, ZW)
    "Africa/Monrovia": "LR", // Liberia
    "Africa/Nairobi": "KE", // Kenya (also DJ, ER, ET, KM, MG, SO, TZ, UG, YT)
    "Africa/Ndjamena": "TD", // Chad
    "Africa/Niamey": "NE",  // Alias for Africa/Lagos for Niger
    "Africa/Nouakchott": "MR", // Alias for Africa/Abidjan for Mauritania
    "Africa/Ouagadougou": "BF", // Alias for Africa/Abidjan for Burkina Faso
    "Africa/Porto-Novo": "BJ", // Alias for Africa/Lagos for Benin
    "Africa/Sao_Tome": "ST", // São Tomé and Príncipe
    "Africa/Tripoli": "LY",  // Libya
    "Africa/Tunis": "TN",   // Tunisia
    "Africa/Windhoek": "NA", // Namibia

    // === America (North & South) ===
    "America/Adak": "US", // US (Alaska, western Aleutians)
    "America/Anchorage": "US", // US (Alaska)
    "US/Alaska": "US", // Alias
    "America/Araguaina": "BR", // Brazil (Tocantins)
    "America/Argentina/Buenos_Aires": "AR", // Argentina (Buenos Aires)
    "America/Argentina/Catamarca": "AR", // Argentina (Catamarca, Chubut)
    "America/Argentina/Cordoba": "AR", // Argentina (most areas)
    "America/Argentina/Jujuy": "AR", // Argentina (Jujuy)
    "America/Argentina/La_Rioja": "AR", // Argentina (La Rioja)
    "America/Argentina/Mendoza": "AR", // Argentina (Mendoza)
    "America/Argentina/Rio_Gallegos": "AR", // Argentina (Santa Cruz)
    "America/Argentina/Salta": "AR", // Argentina (Salta, La Pampa, Neuquen, Rio Negro)
    "America/Argentina/San_Juan": "AR", // Argentina (San Juan)
    "America/Argentina/San_Luis": "AR", // Argentina (San Luis)
    "America/Argentina/Tucuman": "AR", // Argentina (Tucuman)
    "America/Argentina/Ushuaia": "AR", // Argentina (Tierra del Fuego)
    "America/Asuncion": "PY", // Paraguay
    "America/Bogota": "CO", // Colombia
    "America/Boise": "US", // US (Idaho)
    "America/Buenos_Aires": "AR", // Alias for America/Argentina/Buenos_Aires
    "America/Cambridge_Bay": "CA", // Canada (Nunavut)
    "America/Cancun": "MX", // Mexico (Quintana Roo)
    "America/Caracas": "VE", // Venezuela
    "America/Cayenne": "GF", // French Guiana
    "America/Chicago": "US", // US (Central Time)
    "US/Central": "US", // Alias
    "CST6CDT": "US",     // POSIX-style alias
    "America/Chihuahua": "MX", // Mexico (Chihuahua)
    "America/Ciudad_Juarez": "MX", // Mexico (Juárez)
    "America/Costa_Rica": "CR", // Costa Rica
    "America/Cuiaba": "BR", // Brazil (Mato Grosso)
    "America/Denver": "US", // US (Mountain Time)
    "US/Mountain": "US", // Alias
    "MST7MDT": "US",     // POSIX-style alias
    "America/Detroit": "US", // US (Michigan)
    "America/Edmonton": "CA", // Canada (Alberta)
    "America/El_Salvador": "SV", // El Salvador
    "America/Fort_Nelson": "CA", // Canada (British Columbia)
    "America/Guatemala": "GT", // Guatemala
    "America/Halifax": "CA", // Canada (Atlantic Time)
    "America/Havana": "CU", // Cuba
    "America/Hermosillo": "MX", // Mexico (Sonora)
    // "America/Havana": "CU", // Cuba
    "America/Indianapolis": "US", // US (Indiana)
    "America/Indiana/Indianapolis": "US", // Canonical for Indiana
    "America/Indiana/Knox": "US", // US (Indiana)
    "America/Indiana/Marengo": "US", // US (Indiana)
    "America/Indiana/Petersburg": "US", // US (Indiana)
    "America/Indiana/Tell_City": "US", // US (Indiana)
    "America/Indiana/Vevay": "US", // US (Indiana)
    "America/Indiana/Vincennes": "US", // US (Indiana)
    "America/Indiana/Winamac": "US", // US (Indiana)
    "America/Jamaica": "JM", // Jamaica
    "America/Juneau": "US", // US (Alaska)
    "America/Kingston": "JM", // Alias for America/Jamaica
    "America/La_Paz": "BO", // Bolivia
    "America/Lima": "PE", // Peru
    "America/Los_Angeles": "US", // US (Pacific Time)
    "US/Pacific": "US", // Alias
    "PST8PDT": "US",     // POSIX-style alias
    "America/Managua": "NI", // Nicaragua
    "America/Mexico_City": "MX", // Mexico
    "America/Monterrey": "MX", // Mexico (Monterrey)
    "America/Montevideo": "UY", // Uruguay
    "America/Nassau": "BS", // Bahamas
    "America/New_York": "US", // US (Eastern Time)
    "US/Eastern": "US", // Alias
    "EST5EDT": "US",     // POSIX-style alias
    "America/Panama": "PA", // Panama
    "America/Phoenix": "US", // US (Arizona, no DST)
    "US/Arizona": "US",  // Alias
    "MST": "US",         // Alias for Mountain Standard Time (without DST)
    "America/Port-au-Prince": "HT", // Haiti
    "America/Puerto_Rico": "PR", // Puerto Rico (US Territory)
    "America/Santiago": "CL", // Chile
    "America/Santo_Domingo": "DO", // Dominican Republic
    "America/Sao_Paulo": "BR", // Brazil (Sao Paulo)
    "America/St_Johns": "CA", // Canada (Newfoundland)
    "America/Tegucigalpa": "HN", // Honduras
    "America/Toronto": "CA", // Canada (Ontario, Quebec)
    "America/Vancouver": "CA", // Canada (British Columbia)
    "America/Winnipeg": "CA", // Canada (Manitoba)

    // === Antarctica ===
    "Antarctica/Casey": "AQ", // Antarctica (various research stations)
    "Antarctica/Davis": "AQ",
    "Antarctica/DumontDUrville": "AQ",
    "Antarctica/Macquarie": "AU", // Australia (Macquarie Island)
    "Antarctica/Mawson": "AQ",
    "Antarctica/McMurdo": "AQ", // New Zealand (Scott Base)
    "Antarctica/Palmer": "AQ",
    "Antarctica/Rothera": "AQ",
    "Antarctica/Syowa": "AQ",
    "Antarctica/Troll": "AQ",
    "Antarctica/Vostok": "AQ",

    // === Asia ===
    "Asia/Almaty": "KZ", // Kazakhstan (largest city)
    "Asia/Amman": "JO", // Jordan
    "Asia/Baghdad": "IQ", // Iraq
    "Asia/Baku": "AZ", // Azerbaijan
    "Asia/Bangkok": "TH", // Thailand (also KH, LA)
    "Asia/Beirut": "LB", // Lebanon
    "Asia/Bishkek": "KG", // Kyrgyzstan
    "Asia/Brunei": "BN", // Brunei
    "Asia/Calcutta": "IN", // Alias for Asia/Kolkata
    "Asia/Chongqing": "CN", // Alias for Asia/Shanghai (historical)
    "Asia/Colombo": "LK", // Sri Lanka
    "Asia/Damascus": "SY", // Syria
    "Asia/Dhaka": "BD", // Bangladesh
    "Asia/Dubai": "AE", // United Arab Emirates (also OM)
    "Asia/Dili": "TL", // Timor-Leste
    "Asia/Gaza": "PS", // Palestine
    "Asia/Hong_Kong": "HK", // Hong Kong
    "Asia/Ho_Chi_Minh": "VN", // Vietnam
    "Asia/Irkutsk": "RU", // Russia (Irkutsk)
    "Asia/Jakarta": "ID", // Indonesia (Java, Sumatra)
    "Asia/Jayapura": "ID", // Indonesia (Papua)
    "Asia/Jerusalem": "IL", // Israel
    "Asia/Kabul": "AF", // Afghanistan
    "Asia/Karachi": "PK", // Pakistan
    "Asia/Kathmandu": "NP", // Nepal
    "Asia/Kolkata": "IN", // India
    "Asia/Kuala_Lumpur": "MY", // Malaysia
    "Asia/Kuwait": "KW", // Kuwait (also BH, QA)
    "Asia/Macau": "MO", // Macau
    "Asia/Manila": "PH", // Philippines
    "Asia/Muscat": "OM", // Alias for Asia/Dubai for Oman
    "Asia/Nicosia": "CY", // Cyprus (partially Asia/Europe)
    "Asia/Novosibirsk": "RU", // Russia (Novosibirsk)
    "Asia/Phnom_Penh": "KH", // Cambodia (alias for Asia/Bangkok)
    "Asia/Pontianak": "ID", // Indonesia (Borneo)
    "Asia/Qatar": "QA", // Alias for Asia/Kuwait
    "Asia/Riyadh": "SA", // Saudi Arabia
    "Asia/Samarkand": "UZ", // Alias for Asia/Tashkent for Uzbekistan
    "Asia/Seoul": "KR", // South Korea
    "Asia/Shanghai": "CN", // China (most populous)
    "Asia/Singapore": "SG", // Singapore
    "Asia/Taipei": "TW", // Taiwan
    "Asia/Tashkent": "UZ", // Uzbekistan
    "Asia/Tbilisi": "GE", // Georgia
    "Asia/Tehran": "IR", // Iran
    "Asia/Thimphu": "BT", // Bhutan
    "Asia/Tokyo": "JP", // Japan
    "Asia/Ulaanbaatar": "MN", // Mongolia
    "Asia/Urumqi": "CN", // China (Xinjiang - historical, often treated as Shanghai)
    "Asia/Vientiane": "LA", // Laos (alias for Asia/Bangkok)
    "Asia/Vladivostok": "RU", // Russia (Vladivostok)
    "Asia/Yakutsk": "RU", // Russia (Yakutsk)
    "Asia/Yekaterinburg": "RU", // Russia (Yekaterinburg)
    "Asia/Yerevan": "AM", // Armenia

    // === Atlantic ===
    "Atlantic/Azores": "PT", // Portugal (Azores)
    "Atlantic/Bermuda": "BM", // Bermuda (UK Overseas Territory)
    "Atlantic/Canary": "ES", // Spain (Canary Islands)
    "Atlantic/Cape_Verde": "CV", // Cape Verde
    "Atlantic/Faroe": "FO", // Faroe Islands (Denmark)
    "Atlantic/Madeira": "PT", // Portugal (Madeira)
    "Atlantic/Reykjavik": "IS", // Iceland (alias for Africa/Abidjan due to UTC offset)
    "Atlantic/South_Georgia": "GS", // South Georgia and the South Sandwich Islands (UK)
    "Atlantic/Stanley": "FK", // Falkland Islands (UK)

    // === Australia ===
    "Australia/Adelaide": "AU", // South Australia
    "Australia/Brisbane": "AU", // Queensland (no DST)
    "Australia/Broken_Hill": "AU", // New South Wales (Silver City)
    "Australia/Darwin": "AU", // Northern Territory (no DST)
    "Australia/Hobart": "AU", // Tasmania
    "Australia/Lindeman": "AU", // Queensland (Whitsunday region)
    "Australia/Lord_Howe": "AU", // Lord Howe Island (NSW)
    "Australia/Melbourne": "AU", // Victoria
    "Australia/Perth": "AU", // Western Australia
    "Australia/Sydney": "AU", // New South Wales

    // === Europe ===
    "Europe/Amsterdam": "NL", // Netherlands
    "Europe/Andorra": "AD", // Andorra
    "Europe/Athens": "GR", // Greece
    "Europe/Belgrade": "RS", // Serbia (also BA, HR, ME, MK, SI)
    "Europe/Berlin": "DE", // Germany (also AT, CH, LI, LU, SI)
    "Europe/Bratislava": "SK", // Slovakia (alias for Europe/Prague)
    "Europe/Brussels": "BE", // Belgium (also FR, LU, MC)
    "Europe/Bucharest": "RO", // Romania
    "Europe/Budapest": "HU", // Hungary
    "Europe/Chisinau": "MD", // Moldova
    "Europe/Copenhagen": "DK", // Denmark
    "Europe/Dublin": "IE", // Ireland
    "Europe/Gibraltar": "GI", // Gibraltar (UK Overseas Territory)
    "Europe/Helsinki": "FI", // Finland (also AX)
    "Europe/Istanbul": "TR", // Turkey
    "Europe/Kaliningrad": "RU", // Russia (Kaliningrad Oblast)
    "Europe/Kiev": "UA", // Ukraine (Kyiv)
    "Europe/Kirov": "RU", // Russia (Kirov Oblast)
    "Europe/Kyiv": "UA", // Canonical for Ukraine's capital
    "Europe/Lisbon": "PT", // Portugal
    "Europe/London": "GB", // United Kingdom (also GG, IM, JE)
    "Europe/Luxembourg": "LU", // Alias for Europe/Brussels
    "Europe/Madrid": "ES", // Spain (mainland)
    "Europe/Malta": "MT", // Malta
    "Europe/Minsk": "BY", // Belarus
    "Europe/Monaco": "MC", // Alias for Europe/Brussels
    "Europe/Moscow": "RU", // Russia (Moscow)
    "Europe/Oslo": "NO", // Norway
    "Europe/Paris": "FR", // France
    "Europe/Podgorica": "ME", // Alias for Europe/Belgrade for Montenegro
    "Europe/Prague": "CZ", // Czech Republic (also SK)
    "Europe/Riga": "LV", // Latvia
    "Europe/Rome": "IT", // Italy (also SM, VA)
    "Europe/Samara": "RU", // Russia (Samara Oblast)
    "Europe/San_Marino": "SM", // Alias for Europe/Rome
    "Europe/Sarajevo": "BA", // Bosnia and Herzegovina (alias for Europe/Belgrade)
    "Europe/Simferopol": "UA", // Ukraine (Crimea - disputed)
    "Europe/Skopje": "MK", // North Macedonia (alias for Europe/Belgrade)
    "Europe/Sofia": "BG", // Bulgaria
    "Europe/Stockholm": "SE", // Sweden
    "Europe/Tallinn": "EE", // Estonia
    "Europe/Tirane": "AL", // Albania
    "Europe/Uzhgorod": "UA", // Ukraine (Uzhhorod)
    "Europe/Vaduz": "LI", // Alias for Europe/Berlin for Liechtenstein
    "Europe/Vatican": "VA", // Alias for Europe/Rome
    "Europe/Vienna": "AT", // Austria (alias for Europe/Berlin)
    "Europe/Vilnius": "LT", // Lithuania
    "Europe/Volgograd": "RU", // Russia (Volgograd Oblast)
    "Europe/Warsaw": "PL", // Poland
    "Europe/Zagreb": "HR", // Croatia (alias for Europe/Belgrade)
    "Europe/Zaporozhye": "UA", // Ukraine (Zaporizhzhia)
    "Europe/Zurich": "CH", // Switzerland

    // === Indian Ocean ===
    "Indian/Antananarivo": "MG", // Madagascar (alias for Africa/Nairobi)
    "Indian/Chagos": "IO", // British Indian Ocean Territory
    "Indian/Christmas": "CX", // Christmas Island (Australia)
    "Indian/Cocos": "CC", // Cocos (Keeling) Islands (Australia)
    "Indian/Comoro": "KM", // Comoros (alias for Africa/Nairobi)
    "Indian/Kerguelen": "TF", // French Southern and Antarctic Lands
    "Indian/Mahe": "SC", // Seychelles
    "Indian/Maldives": "MV", // Maldives
    "Indian/Mauritius": "MU", // Mauritius
    "Indian/Mayotte": "YT", // Mayotte (France) (alias for Africa/Nairobi)
    "Indian/Reunion": "RE", // Réunion (France)

    // === Pacific ===
    "Pacific/Apia": "WS", // Samoa
    "Pacific/Auckland": "NZ", // New Zealand
    "Pacific/Chatham": "NZ", // New Zealand (Chatham Islands)
    "Pacific/Easter": "CL", // Chile (Easter Island)
    "Pacific/Fiji": "FJ", // Fiji
    "Pacific/Funafuti": "TV", // Tuvalu
    "Pacific/Galapagos": "EC", // Ecuador (Galapagos Islands)
    "Pacific/Gambier": "PF", // French Polynesia (Gambier Islands)
    "Pacific/Guadalcanal": "SB", // Solomon Islands
    "Pacific/Guam": "GU", // Guam (US Territory)
    "Pacific/Honolulu": "US", // US (Hawaii)
    "US/Hawaii": "US", // Alias
    "Pacific/Kiritimati": "KI", // Kiribati (Christmas Island)
    "Pacific/Majuro": "MH", // Marshall Islands
    "Pacific/Marquesas": "PF", // French Polynesia (Marquesas Islands)
    "Pacific/Midway": "UM", // US Minor Outlying Islands (Midway Atoll - alias for Pacific/Pago_Pago)
    "Pacific/Nauru": "NR", // Nauru
    "Pacific/Noumea": "NC", // New Caledonia (France)
    "Pacific/Pago_Pago": "AS", // American Samoa (US Territory)
    "Pacific/Palau": "PW", // Palau
    "Pacific/Port_Moresby": "PG", // Papua New Guinea
    "Pacific/Rarotonga": "CK", // Cook Islands (New Zealand)
    "Pacific/Saipan": "MP", // Northern Mariana Islands (US)
    "Pacific/Tahiti": "PF", // French Polynesia (Society Islands)
    "Pacific/Tarawa": "KI", // Kiribati (Gilbert Islands)
    "Pacific/Tongatapu": "TO", // Tonga
    "Pacific/Wake": "UM", // US Minor Outlying Islands (Wake Island)
    "Pacific/Wallis": "WF", // Wallis and Futuna (France)

    // === Aliases for Generic GMT Offsets (less reliable for country inference) ===
    // These generally indicate a fixed UTC offset and don't change with DST.
    // They are often returned by older systems or specific configurations.
    // Assigning a country to these is even more of a guess.
    "GMT": "GB", // Greenwich Mean Time (primary association)
    "UTC": "GB", // Coordinated Universal Time (no specific country, often associated with GMT/London)
    "Etc/GMT": "GB", // Standard IANA "Etc" time zones for fixed offsets
    "Etc/GMT+1": "CV", // Example: Some regions West of GMT
    "Etc/GMT-1": "FR", // Example: Some regions East of GMT
    // ... you could add more Etc/GMT+/-X if needed, but they are very generic

    // === Windows/Legacy/POSIX Style Aliases (often found in older systems) ===
    // These are often mapped directly to their IANA counterparts by modern browsers,
    // but some environments might still report them.
    "EST": "US",  // Eastern Standard Time (without DST, generic)
    "CST": "US",  // Central Standard Time (without DST, generic)
    "PST": "US",  // Pacific Standard Time (without DST, generic)
    "AKST": "US", // Alaska Standard Time (without DST, generic)
    "HST": "US",  // Hawaii Standard Time (without DST, generic)
    "ECT": "FR",  // European Central Time (common but unofficial alias)
    "CET": "DE",  // Central European Time (common alias, assign to Germany as a primary example)
    "MET": "DE",  // Middle European Time (another common alias)
    "EET": "GR",  // Eastern European Time (common alias, assign to Greece as a primary example)
    "WET": "PT",  // Western European Time (common alias, assign to Portugal as a primary example)
    "GMT+1": "FR", // Generic fixed offset, inferred example
    "GMT+5": "RU", // Generic fixed offset, inferred example
    "GMT+5:30": "IN", // Matches India's offset
    "GMT-5": "US", // Generic fixed offset, inferred example
};